import * as Sentry from '@sentry/react';
import { ChatLoggerProvider } from "@trinity/chat-components/containers/Chat/LoggerProvider.js";

export const LoggerProvider = ({ children }: { children: React.ReactNode }) => {

  return (
    <ChatLoggerProvider
      addBreadcrumb={Sentry.addBreadcrumb}
      captureMessage={Sentry.captureMessage}
      captureException={Sentry.captureException}
      setContext={Sentry.setContext}
    >
      {children}
    </ChatLoggerProvider>
  );
};